import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface PunchIn {
  dayString: string;
  punchInTime: string;
  recordId: string;
  sessionStatus: string;
  autoClosedPreviousSession: boolean;
}

export type PunchInPayload = {
  userId?: string;
  punchInTime: string;
  source: string;
  deviceId: string;
  location: Location;
};

export interface Location {
  lat: number | null;
  lng: number | null;
}

export type PunchInResponse = {
  success: boolean;
  message: string;
  data: PunchIn;
};

const addPunchIn = async (
  payload: PunchInPayload
): Promise<PunchInResponse> => {
  const { data } = await customAxios.post<PunchInResponse>(
    "/attendance/punch-in-v2",
    payload
  );
  return data;
};

export const useAddPunchIn = () => {
  const queryClient = useQueryClient();

  return useMutation<PunchInResponse, AxiosError, PunchInPayload>({
    mutationFn: addPunchIn,
    onSuccess: async (response) => {
      showNotification({
        title: "Clock In Success",
        message: response.message,
        color: "green",
      });
      await queryClient.invalidateQueries(["attendance"]);
      await queryClient.invalidateQueries(["table-attendace"]);
      await queryClient.invalidateQueries(["attendance-summary"]);
    },
    onError: (error) => {
      const errMsg =
        (error.response?.data as { message?: string })?.message ??
        "Clock in failed";
      showNotification({
        title: "Clock In Error",
        message: errMsg,
        color: "red",
      });
    },
  });
};
